import { useZero } from "@rocicorp/zero/react";
import { sharedMutators } from "../../../../shared/mutators";
import { useFormatRelativeTime } from "../../../hooks/useFormatRelativeTime";
import { StatusPill } from "../../StatusPill";
import { Text } from "../../Text";

type Destination = {
  id: string;
  lastError: string | null;
  cursorTimestamp: number;
  testingStartedAt: number | null;
};

type Props = {
  destination: Destination;
};

export function DestinationStatusPill({ destination }: Props) {
  const z = useZero();
  const formatRelativeTime = useFormatRelativeTime();
  const isPending = destination.testingStartedAt !== null;
  const failed = destination.lastError !== null;
  const label = failed ? "Error" : "Active";
  const tooltip = isPending
    ? "Testing connection…"
    : destination.lastError ||
      `Last sent ${formatRelativeTime(destination.cursorTimestamp)}`;

  return (
    <StatusPill
      color={failed ? "red" : "green"}
      label={label}
      detail={
        <Text variant="text-small-md" color="var(--tooltip-fg)">
          {tooltip}
        </Text>
      }
      running={isPending}
      action={{
        label: "Test connection",
        onClick: () =>
          z.mutate(
            sharedMutators.testAuditLogDestination({ id: destination.id })
          ),
      }}
      triggerLabel={`${label}${isPending ? ", testing connection" : ""}`}
      compactAt={failed ? 52 : 58}
      compactIcon={failed ? "x" : "check"}
    />
  );
}
